export const nonDecodedSettings = [
  // pictures objects
  'joinOfferScreenJoinScreenPicture',
  'campOfferLink',
  'footerMenuImageFileSkolkovo',
]
